import * as React from "react";

export const PrivacySection = () => {
    const privacyUrl = "https://www.conexus.lv/privatuma-pazinojums";

    return (
        <div className="privacy-section">
            <p>Nosūtot pieteikumu, Jūs iesniedzat savus personas datus.</p>
            <div>
                <strong>Pārzinis: </strong>AS “Conexus Baltic Grid”
            </div>
            <div>
                <strong>Kontaktinformācija:</strong> Stigu iela 14, Rīga, LV-1021, e-pasts:{" "}
                <a className="url" href="mailto:info@conexus.lv">
                    info@conexus.lv
                </a>
                , tālrunis +371 67 087 900
            </div>
            <div>
                <strong>Datu apstrādes mērķis:</strong> Sagatavot un piešķirt darbu veikšanas atļauju AS “Conexus Baltic
                Grid” objektu aizsargjoslu zonās
            </div>
            <div>
                Papildus informācija par datu apstrādi pieejama &nbsp;
                <a className="url" href={privacyUrl} rel="noopener noreferrer" target="_blank">
                    Privātuma politikā.
                </a>
            </div>
            <p></p>
            <strong>
                Atļauja tiek sagatavota papīra formātā un tiek izsniegta uz vietas darbu saskaņošanas brīdī uzņēmuma
                paraksttiesīgai amatpersonai. Pilnvarotajām personām obligāti jāiesniedz pilnvaru apliecinošs dokuments,
                to pievienojot elektroniski kā pielikumu.
            </strong>
        </div>
    );
};
